import styled from 'styled-components'

import HeartOnIcon from '../../icons/BucketlistHeartOn'
import HeartOffIcon from '../../icons/BucketlistHeartOff'

import { LinkOrAWrapper } from './LinkOrA'

/* Must follow the slider in the DOM to stack above it without a z-index
   (MediaWrapper's transform creates the containing stacking context). */
export const CardImageOverlay = styled.div`
  position: absolute;
  inset: 0;
  padding: ${({ theme }) => theme['-ds-space-04']};

  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;

  /* Clicks in empty overlay space fall through to the slide link. */
  pointer-events: none;
`

export const OverlayChips = styled.div`
  flex: 1 0 0;
  min-width: 0;

  display: flex;
  align-items: center;
  gap: 8px;

  pointer-events: none;

  > * {
    pointer-events: auto;
  }

  ${LinkOrAWrapper} {
    min-width: 0;

    a {
      display: block;
    }
  }
`

const HeartChip = styled.button.attrs(
  ({ isActive, ...props }: { isActive?: boolean; 'aria-label'?: string }) => {
    const label =
      props['aria-label'] ||
      (isActive ? 'Remove from bucket list' : 'Add to bucket list')

    return {
      type: 'button' as const,
      'aria-label': label,
    }
  },
)<{ isActive?: boolean }>`
  pointer-events: auto;
  flex-shrink: 0;
  position: relative;

  appearance: none;
  border: none;
  outline: none;
  margin: 0;
  padding: 0;

  width: 32px;
  height: 32px;
  background: transparent;
  color: white;

  /* Preserves the legacy 55px touch target around the 32px heart. */
  &::after {
    content: '';
    position: absolute;
    inset: -11.5px;
  }

  svg {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    width: 32px;
    height: 32px;

    transition: color 150ms ease-out;

    &:first-child {
      color: rgba(0, 0, 0, 0.3);
    }
  }

  ${({ isActive }) =>
    isActive &&
    `
    svg:first-child {
      color: #ebcec9;
    }
  `}
`

type OverlayBucketListButtonProps = {
  onClick?: (...args: any[]) => any
  isActive?: boolean
  'aria-label'?: string
}

export const OverlayBucketListButton = (
  props: OverlayBucketListButtonProps,
) => (
  <HeartChip {...props}>
    <HeartOnIcon />
    <HeartOffIcon />
  </HeartChip>
)

export default CardImageOverlay
